export interface WhatsAppInboxRealtimeSession {
  readonly selectedChatId: string | null;
  readonly onError: ((message: string) => void) | null;
}

const idleSession: WhatsAppInboxRealtimeSession = {
  selectedChatId: null,
  onError: null,
};

let session: WhatsAppInboxRealtimeSession = idleSession;

export function readWhatsAppInboxRealtimeSession(): WhatsAppInboxRealtimeSession {
  return session;
}

/** Presenter publishes the open chat so the single shell socket can patch that thread. */
export function bindWhatsAppInboxRealtimeSession(next: WhatsAppInboxRealtimeSession): () => void {
  session = next;
  return () => {
    if (session === next) {
      session = idleSession;
    }
  };
}
